import { Col, Row } from "react-bootstrap";
import { getGraphicsDashboard } from "../../apis/apiDashboard";
import ModalGraph from "../Modal/ModalGraph";
import { useEffect, useState } from "react";
import { Loading } from "../Loading/String/Loading";
import { Indicators } from "./Indicator/Indicators";
import { Graphics } from "./Graphic/Graphics";
import "./Dashboard.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { MCButton } from "../MainComponents";
export const Dashboard = () => {
  const [t] = useTranslation("dashboard");
  const [isLoading, setIsLoading] = useState(true);
  const [loadingIndicators, setLoadingIndicators] = useState(false);
  const [loadingGraphics, setLoadingGraphics] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [graphics, setGraphics] = useState({});
  const [indicators, setIndicators] = useState({});
  //const [lastReport, setLastReport] = useState({});
  const navigate = useNavigate();

  const [order, setOrder] = useState({});

  useEffect(() => {
    if (!modalOpen) {
      setIsLoading(true);
      getDataElement();
    }
  }, []);
  useEffect(() => {
    if (loadingIndicators) getDataElement();
  }, [loadingIndicators]);
  useEffect(() => {
    if (loadingGraphics) getDataElement();
  }, [loadingGraphics]);

  const getDataElement = async () => {
    const response = await getGraphicsDashboard();
    //const lastReport = await getLastReport();
    setGraphics(response.graphics);

    setIndicators(response.indicators);
    setOrder(response.order || {});
    //setLastReport(lastReport);
    setIsLoading(false);
    setLoadingIndicators(false);
    setLoadingGraphics(false);
  };

  const breadcrumbItems = [
    { label: t("dashboard.home"), route: "/" },
    { label: "Dashboard" },
  ];

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div id="dashboard" className="dashboard">
          

          <div>
            <Row>
              <Col lg="12 p-0">
                
                <div className="indicators">
                  {loadingIndicators ? (
                    <Loading />
                  ) : (
                    <Indicators
                      indicatorsData={indicators}
                      stateLoading={setLoadingIndicators}
                    />
                  )}
                </div>

                <div className="graphics-content">
                  {loadingGraphics ? (
                    <Loading />
                  ) : (
                    <Graphics
                      graphicsData={graphics}
                      stateLoading={setLoadingGraphics}
                      order={order}
                    />
                  )}
                </div>

                {modalOpen && (
                  <ModalGraph
                    show={modalOpen}
                    onHide={() => setModalOpen(false)}
                    stateLoadingIndicators={setLoadingIndicators}
                    stateLoadingGraphics={setLoadingGraphics}
                  />
                )}
              </Col>              
            </Row>
          </div>
        </div>
      )}
    </>
  );
};
